import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addRequest, updateLead } from "../redux/action/request";
import UploadIcon from "../assets/icons/upload";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const UnifiedVehicleForm = ({ data = {}, onSubmit }) => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  
  const [formData, setFormData] = useState({
    vehicleType: data?.vehicleType || "",
    policyType: data?.policyType || "",
    previousPolicytype: data?.previousPolicytype || "",
    previousYearclame: data?.previousYearclame || "",
    policyExpirydate: data?.policyExpirydate || "",
    policyMorethan90: data?.policyMorethan90 || false,
    ncbOfPreviousPolicy: data?.ncbOfPreviousPolicy || "",
    ODInsurer: data?.ODInsurer || "",
    registerNumber: data?.registerNumber || "",
    make: data?.make || "",
    vehicleModel: data?.vehicleModel || "",
    GVC: data?.GVC || "",
    registrationDate: data?.registrationDate || "",
    manufactureDate: data?.manufactureDate || "",
    fuelType: data?.fuelType || "",
    vehicleChassis: data?.vehicleChassis || "",
    vehicleEngineNumber: data?.vehicleEngineNumber || "",
    vehicleDetailURL: data?.vehicleDetailURL || null,
    previousPolicyURL: data?.previousPolicyURL || null,
    ownerDetail: {
      ownerName: data?.ownerDetail?.ownerName || "",
      ownerPhone: data?.ownerDetail?.ownerPhone || "",
      ownerAddress: data?.ownerDetail?.ownerAddress || "",
      ownerEmail: data?.ownerDetail?.ownerEmail || "",
    },
  });

  const [selectedFiles, setSelectedFiles] = useState({
    vehicleDetailURL: data?.vehicleDetailURL ? "Uploaded" : null,
    previousPolicyURL: data?.previousPolicyURL ? "Uploaded" : null,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleOwnerChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      ownerDetail: {
        ...prev.ownerDetail,
        [name]: value,
      },
    }));
  };

  const handleFileChange = (e, field) => {
    const file = e.target.files[0];
    if (file) {
      // Check file type
      const validTypes = ["image/jpeg", "image/png", "application/pdf"];
      if (!validTypes.includes(file.type)) {
        toast.error("Only JPG, PNG, or PDF files are allowed");
        return;
      }

      // Check file size (5MB max)
      if (file.size > 5 * 1024 * 1024) {
        toast.error("File size must be less than 5MB");
        return;
      }

      setSelectedFiles((prev) => ({
        ...prev,
        [field]: file.name,
      }));
      setFormData((prev) => ({
        ...prev,
        [field]: file,
      }));
    }
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    // Validate required fields
    if (!formData.vehicleType) {
      toast.error("Please select a vehicle type");
      setLoading(false);
      return;
    }

    if (!formData.policyType) {
      toast.error("Please select a policy type");
      setLoading(false);
      return;
    }

    // if (formData.policyType !== "Third Party" && !formData.policyMorethan90) {
    //   if (!formData.previousPolicytype) {
    //     toast.error("Please select a previous policy type");
    //     setLoading(false);
    //     return;
    //   }

    //   if (!formData.previousYearclame) {
    //     toast.error("Please indicate if claim was made in previous year");
    //     setLoading(false);
    //     return;
    //   }

    //   if (
    //     formData.previousYearclame === "No" &&
    //     !formData.ncbOfPreviousPolicy
    //   ) {
    //     toast.error("Please select NCB percentage");
    //     setLoading(false);
    //     return;
    //   }

    //   if (formData.previousYearclame === "No" && !formData.ODInsurer) {
    //     toast.error("Please enter previous policy OD insurer");
    //     setLoading(false);
    //     return;
    //   }
    // }

    if (!formData.registerNumber) {
      toast.error("Registration Number is required");
      setLoading(false);
      return;
    }

    if (!formData.vehicleDetailURL) {
      toast.error("Vehicle Details (RC) file is required");
      setLoading(false);
      return;
    }

    if (!formData.ownerDetail.ownerName) {
      toast.error("Owner Name is required");
      setLoading(false);
      return;
    }

    if (
      !formData.ownerDetail.ownerPhone ||
      formData.ownerDetail.ownerPhone.length < 10
    ) {
      toast.error("Valid Owner Phone (10 digits) is required");
      setLoading(false);
      return;
    }

    try {
      // Prepare the data for submission
      const submissionData = {
        ...formData,
        userId: localStorage.getItem("userId"),
        userType: "ProLeadPartner",
        requestSent: true,
        quotationMade: false,
        paymentDone: false,
        policyUpdated: false,
      };

      // Handle file uploads
      if (formData.vehicleDetailURL instanceof File) {
        submissionData.vehicleDetailURL = await convertToBase64(
          formData.vehicleDetailURL
        );
      }

      if (formData.previousPolicyURL instanceof File) {
        submissionData.previousPolicyURL = await convertToBase64(
          formData.previousPolicyURL
        );
      }

      let response;
      if (data?._id) {
        // Update existing lead
        response = await dispatch(updateLead(submissionData, data._id));
      } else {
        // Create new lead
        response = await dispatch(addRequest(submissionData));
      }

      // Handle the response
      if (response && (response.status === 200 || response.status === 201)) {
        toast.success(
          data?._id
            ? "Lead updated successfully!"
            : "Lead created successfully!"
        );
        setTimeout(() => {
          navigate("/lead"); // Redirect to leads page
        }, 2000);
      } else {
        throw new Error("Failed to submit form");
      }
    } catch (error) {
      setLoading(false);
      console.error("Error submitting form:", error);
      toast.error("Failed to submit form. Please try again.");
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={5000} />
      
      <form
        onSubmit={handleSubmit}
        className="max-w-4xl mx-auto p-6 bg-white rounded-xl shadow-sm"
      >
        <div className="space-y-8">
          {/* Vehicle Type Section */}
          <section className="bg-gray-50 p-6 rounded-lg">
            <h2 className="text-xl font-semibold text-gray-800 mb-4 pb-2 border-b border-gray-200">
              Vehicle Information
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {["Bike", "Car", "Commercial Vehicle"].map((type) => (
                <button
                  key={type}
                  type="button"
                  className={`p-4 rounded-lg transition-all duration-200 ${
                    formData.vehicleType === type
                      ? "bg-blue-100 border-2 border-blue-500 text-blue-700"
                      : "bg-white border border-gray-300 hover:border-blue-300"
                  }`}
                  onClick={() =>
                    setFormData((prev) => ({ ...prev, vehicleType: type }))
                  }
                >
                  <div className="font-medium">{type}</div>
                  {type === "Commercial Vehicle" && (
                    <small className="text-xs block mt-1">
                      (Taxi/Auto/Bus/Goods Carrying Vehicles etc.)
                    </small>
                  )}
                </button>
              ))}
            </div>
          </section>

          {/* Policy Details Section */}
          <section className="bg-gray-50 p-6 rounded-lg">
            <h2 className="text-xl font-semibold text-gray-800 mb-4 pb-2 border-b border-gray-200">
              Policy Details
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Policy Type *
                  </label>
                  <select
                    name="policyType"
                    value={formData.policyType}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                    required
                  >
                    <option value="">Select Policy Type</option>
                    <option value="Comprehensive">Comprehensive</option>
                    <option value="Third Party">Third Party</option>
                    <option value="Own Damage">Own Damage</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Policy Expiry Date
                  </label>
                  <input
                    type="date"
                    name="policyExpirydate"
                    value={formData.policyExpirydate}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                    
                  />
                </div>

                <div className="flex items-center">
                  <input
                    type="checkbox"
                    name="policyMorethan90"
                    checked={formData.policyMorethan90}
                    onChange={handleChange}
                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                  />
                  <label className="ml-2 block text-sm text-gray-700">
                    Policy expired more than 90 days ago
                  </label>
                </div>
              </div>

              {formData.policyType !== "Third Party" &&
                !formData.policyMorethan90 && (
                  <div className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Previous Policy Type
                      </label>
                      <div className="flex flex-wrap gap-3">
                        <select
                          name="previousPolicytype"
                          value={formData.previousPolicytype}
                          onChange={handleChange}
                          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                          
                        >
                          <option value="">Select Previous Policy Type</option>
                          <option value="Comprehensive">Comprehensive</option>
                          <option value="1 yr Own Damage + 5yr Third Party">
                            1 yr Own Damage + 5yr Third Party
                          </option>
                          <option value="Third Party">Third Party</option>
                        </select>
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Claim Made in Previous Year?
                      </label>
                      <select
                        name="previousYearclame"
                        value={formData.previousYearclame}
                        onChange={handleChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                        
                      >
                        <option value="">Select Option</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </div>

                    {formData.previousYearclame === "No" && (
                      <>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            NCB Percentage
                          </label>
                          <select
                            name="ncbOfPreviousPolicy"
                            value={formData.ncbOfPreviousPolicy}
                            onChange={handleChange}
                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                            
                          >
                            <option value="">Select NCB %</option>
                            <option value="0%">0%</option>
                            <option value="20%">20%</option>
                            <option value="25%">25%</option>
                            <option value="35%">35%</option>
                            <option value="45%">45%</option>
                            <option value="50%">50%</option>
                          </select>
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Previous Policy OD Insurer
                          </label>
                          <input
                            type="text"
                            name="ODInsurer"
                            value={formData.ODInsurer}
                            onChange={handleChange}
                            placeholder="Enter insurer name"
                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                            
                          />
                        </div>
                      </>
                    )}
                  </div>
                )}
            </div>
          </section>

          {/* Vehicle Details Section */}
          <section className="bg-gray-50 p-6 rounded-lg">
            <h2 className="text-xl font-semibold text-gray-800 mb-4 pb-2 border-b border-gray-200">
              Vehicle Specifications
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Registration Number *
                  </label>
                  <input
                    type="text"
                    name="registerNumber"
                    value={formData.registerNumber}
                    onChange={handleChange}
                    placeholder="Enter registration number"
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Make
                  </label>
                  <input
                    type="text"
                    name="make"
                    value={formData.make}
                    onChange={handleChange}
                    placeholder="Enter vehicle make"
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                    
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Model 
                  </label>
                  <input
                    type="text"
                    name="vehicleModel"
                    value={formData.vehicleModel}
                    onChange={handleChange}
                    placeholder="Enter vehicle model"
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                    
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    CC / GVC
                  </label>
                  <input
                    type="text"
                    name="GVC"
                    value={formData.GVC}
                    onChange={handleChange}
                    placeholder="Enter CC or GVC"
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>
              </div>

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Registration Date
                  </label>
                  <input
                    type="date"
                    name="registrationDate"
                    value={formData.registrationDate}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                    
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Manufacture Year
                  </label>
                  <input
                    type="text"
                    name="manufactureDate"
                    value={formData.manufactureDate}
                    onChange={handleChange}
                    placeholder="Enter manufacture year"
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                    
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Fuel Type
                  </label>
                  <select
                    name="fuelType"
                    value={formData.fuelType}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                    
                  >
                    <option value="">Select Fuel Type</option>
                    <option value="Petrol">Petrol</option>
                    <option value="Diesel">Diesel</option>
                    <option value="CNG">CNG</option>
                    <option value="Electric">Electric</option>
                    <option value="Hybrid">Hybrid</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Chassis Number
                  </label>
                  <input
                    type="text"
                    name="vehicleChassis"
                    value={formData.vehicleChassis}
                    onChange={handleChange}
                    placeholder="Enter chassis number"
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Engine Number
                  </label>
                  <input
                    type="text"
                    name="vehicleEngineNumber"
                    value={formData.vehicleEngineNumber}
                    onChange={handleChange}
                    placeholder="Enter engine number"
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>
              </div>
            </div>
          </section>

          {/* Document Upload Section */}
          <section className="bg-gray-50 p-6 rounded-lg">
            <h2 className="text-xl font-semibold text-gray-800 mb-4 pb-2 border-b border-gray-200">
              Document Upload
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Vehicle Details (RC) *
                </label>
                <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                  <div className="space-y-1 text-center">
                    <div className="flex text-sm text-gray-600 justify-center">
                      <label className="relative cursor-pointer bg-white rounded-md font-medium text-blue-600 hover:text-blue-500 focus-within:outline-none">
                        <span>Upload a file</span>
                        <input
                          type="file"
                          accept=".jpg,.jpeg,.png,.pdf"
                          onChange={(e) =>
                            handleFileChange(e, "vehicleDetailURL")
                          }
                          className="sr-only"
                          required={!formData.vehicleDetailURL}
                        />
                      </label>
                      <p className="pl-1">or drag and drop</p>
                    </div>
                    <p className="text-xs text-gray-500">
                      PDF, JPG, PNG up to 5MB
                    </p>
                    {selectedFiles.vehicleDetailURL && (
                      <p className="text-green-500 text-sm mt-2">
                        Selected: {selectedFiles.vehicleDetailURL}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Previous Policy Document
                  
                </label>
                <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                  <div className="space-y-1 text-center">
                    <div className="flex text-sm text-gray-600 justify-center">
                      <label className="relative cursor-pointer bg-white rounded-md font-medium text-blue-600 hover:text-blue-500 focus-within:outline-none">
                        <span>Upload a file</span>
                        <input
                          type="file"
                          accept=".jpg,.jpeg,.png,.pdf"
                          onChange={(e) =>
                            handleFileChange(e, "previousPolicyURL")
                          }
                          className="sr-only"
                          
                        />
                      </label>
                      <p className="pl-1">or drag and drop</p>
                    </div>
                    <p className="text-xs text-gray-500">
                      PDF, JPG, PNG up to 5MB
                    </p>
                    {selectedFiles.previousPolicyURL && (
                      <p className="text-green-500 text-sm mt-2">
                        Selected: {selectedFiles.previousPolicyURL}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Owner Details Section */}
          <section className="bg-gray-50 p-6 rounded-lg">
            <h2 className="text-xl font-semibold text-gray-800 mb-4 pb-2 border-b border-gray-200">
              Owner Details
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Owner Name *
                </label>
                <input
                  type="text"
                  name="ownerName"
                  value={formData.ownerDetail.ownerName}
                  onChange={handleOwnerChange}
                  placeholder="Enter owner name"
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Owner Phone *
                </label>
                <input
                  type="tel"
                  name="ownerPhone"
                  value={formData.ownerDetail.ownerPhone}
                  onChange={handleOwnerChange}
                  placeholder="Enter phone number"
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                  minLength="10"
                  maxLength="10"
                  pattern="[0-9]{10}"
                  required
                />
              </div>

              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Owner Address
                </label>
                <input
                  type="text"
                  name="ownerAddress"
                  value={formData.ownerDetail.ownerAddress}
                  onChange={handleOwnerChange}
                  placeholder="Enter full address"
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                  
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Owner Email
                </label>
                <input
                  type="email"
                  name="ownerEmail"
                  value={formData.ownerDetail.ownerEmail}
                  onChange={handleOwnerChange}
                  placeholder="Enter email address"
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
            </div>
          </section>

          {/* Submit Button */}
          <div className="flex justify-end">
            <button
              type="submit"
              disabled={loading}
              className={`px-6 py-3 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors ${
                loading ? "opacity-70 cursor-not-allowed" : ""
              }`}
            >
              {loading ? (
                <span className="flex items-center justify-center">
                  <svg
                    className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  Submitting...
                </span>
              ) : (
                "Submit Quotation"
              )}
            </button>
          </div>
        </div>
      </form>
    </>
  );
};

export default UnifiedVehicleForm;
